import { useEffect, useMemo } from 'react';
import { getSharedSrpPdpItem } from '../../search/property-listing/store-pdp-image-and-property-name';
import { SRP_PDP_SHARED_DATA_KEY } from 'constants/pdp-srp-localStorage-keys';
const LOCALSTORAGE_EXPIRATION_IN_MINUTES = 3;
export const useStoredPdpImageAndPropertyName = propertyId => {
  const sharedData = useMemo(() => getSharedSrpPdpItem().find(item => item.id === propertyId), [propertyId]);
  // clean up the shared pdp data that's longer than 3 minutes
  useEffect(() => {
    const sharedItems = getSharedSrpPdpItem();
    const currentTime = new Date().getTime();
    const validItems = sharedItems.filter(item => Math.round((currentTime - item.timestamp) / 60000) < LOCALSTORAGE_EXPIRATION_IN_MINUTES);
    if (validItems.length !== sharedItems.length) {
      localStorage.setItem(SRP_PDP_SHARED_DATA_KEY, JSON.stringify(validItems));
    }
  }, [sharedData]);
  return sharedData;
};